import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 48 48",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M23.5 3.5c11 0 20 9 20 20s-9 20-20 20-20-9-20-20 9-20 20-20m0-2.5C11.1 1 1 11.1 1 23.5S11.1 46 23.5 46 46 35.9 46 23.5 35.9 1 23.5 1z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 11.2,
			cy: 17.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 19.4,
			cy: 17.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 27.6,
			cy: 17.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 35.8,
			cy: 17.2,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 31.7,
			cy: 11.1,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 23.5,
			cy: 11.1,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 15.3,
			cy: 11.1,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 11.2,
			cy: 29.8,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 19.4,
			cy: 29.8,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 27.6,
			cy: 29.8,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 35.8,
			cy: 29.8,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 31.7,
			cy: 35.9,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 23.5,
			cy: 35.9,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "icon-fill-secondary",
			cx: 15.3,
			cy: 35.9,
			r: 2.2
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M2.6 22.2h41.7v2.5H2.6z"
		})
	]
});
export default SvgIcon;
